export default "__VITE_ASSET__jnCbAYNB__"